import { Controller } from "@hotwired/stimulus"
import CodeMirror from "codemirror"
import "codemirror/mode/htmlmixed/htmlmixed.js"

export default class extends Controller {
  initialize() {
    this.handleThemeChange = this.handleThemeChange.bind(this)
  }

  connect() {
    this.codeMirror = CodeMirror.fromTextArea(this.element, {
      mode: "htmlmixed",
      lineNumbers: false,
      readOnly: this.element.disabled
    })

    this._applyTheme()
    document.addEventListener('theme-switcher:changed', this.handleThemeChange)
  }

  disconnect() {
    document.removeEventListener('theme-switcher:changed', this.handleThemeChange)

    if (this.codeMirror) {
      this.codeMirror.toTextArea()
      this.codeMirror = null
    }
  }

  handleThemeChange() {
    this._applyTheme()
  }

  _applyTheme() {
    if (!this.codeMirror) return

    const isDark = document.documentElement.classList.contains('dark')
    this.codeMirror.getWrapperElement().classList.toggle('cm-dark', isDark)
  }
}
